import { RampWithNameTransform } from '@goldwasserexchange/react-topmodel';
import * as React from 'react';
import { useCellRampNames } from '../../../shared';
export var TableBodyRowCellBase = function () {
    var _a = useCellRampNames('BodyRowCellContainer'), containerRampName = _a.rampName, containerRampFallbacks = _a.rampFallbacks;
    var _b = useCellRampNames('BodyRowCellContent'), contentRampName = _b.rampName, contentRampFallbacks = _b.rampFallbacks;
    return (React.createElement(RampWithNameTransform, { rampName: containerRampName, rampFallbacks: containerRampFallbacks },
        React.createElement(RampWithNameTransform, { rampName: contentRampName, rampFallbacks: contentRampFallbacks })));
};
